import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
  AlertDialogTrigger,
  AlertDialogFooter,
  AlertDialogHeader,
} from 'src/components/shadcn/alert-dialog'
import { AlertDialogProps } from 'src/components/CustomAlertDialog/types'

const AlertDialogDemo = ({
  cancel,
  trigger,
  accept,
  title,
  description,
  isDanger,
  onConfirm,
}: AlertDialogProps) => {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-[10px]">
            {cancel}
          </AlertDialogCancel>
          <AlertDialogAction
            className={`rounded-[10px] ${isDanger ? 'bg-red-600 hover:bg-red-700 text-white' : ''}`}
            onClick={onConfirm}
          >
            {accept}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default AlertDialogDemo
